<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="13.183" height="8" viewBox="0 0 13.183 8">
    <path d="M35.282,44.761l-5.867,5.867a.724.724,0,0,1-1.025,0l-.684-.684a.724.724,0,0,1,0-1.023l4.65-4.671-4.65-4.671a.724.724,0,0,1,0-1.023l.684-.684a.724.724,0,0,1,1.025,0l5.867,5.867A.725.725,0,0,1,35.282,44.761Z" transform="translate(-27.494 -37.657)" class="fill-current"/>
  </svg>  
</template>
